import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Ram() {
  const [ramList, setRamList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем по категории RAM
        const ramItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'ram'
        );

        setRamList(ramItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="ram">
      <h1>Оперативная память</h1>
      <div className="ram__list">
        {ramList.length > 0 ? (
          ramList.map((ram) => (
            <div key={ram.id} className="ram__card">
              <img src={ram.image} alt={ram.name} />
              <h2>{ram.name}</h2>
              <p className="specs">{ram.description}</p>
              <p className="price">{ram.price}</p>
              <Link to={`/components/ram/${ram.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
